export default __webpack_public_path__ + "static/media/pictogramBeaconAwards128.79485b52.svg";